<template>
  <div class="container">
    <router-view v-if="isRouterAlive"></router-view>
    <div v-if="this.$store.state.global.isLoadingShow" id="loadingContainer">
      <van-loading size="15vw" type="spinner" color="#1989fa"></van-loading>
    </div>
    <div class="container" v-if="!isJti">
      <img src="../src/assets/home/logo.png" alt="" class="logo" />
      <div id="loginContainer">
        <div class="inputContainer">
          <img src="../src/assets/home/username.png" alt="" />
          <input type="text" placeholder="请输入账号" v-model="username" />
        </div>
        <div class="inputContainer">
          <img src="../src/assets/home/password.png" alt="" />
          <input type="password" placeholder="请输入密码" v-model="password" />
        </div>
        <div class="btnNext" @click="denglu">立即登录</div>
        <div class="btnWangjimima" @click="wangjimima">忘记密码</div>
        <div class="mimaxiangguanContainer">
          <div class="jizhumima" @click="onRemeber">
            <img :src="iconUrl" alt="" />
            <p>记住密码</p>
          </div>
          <p @click="zhucezhanghao">注册账号</p>
        </div>
      </div>
    </div>
    <div class="container" v-if="isZhucezhanghao">
      <img src="../src/assets/home/logo.png" alt="" class="logo" />
      <div class="phone infoContainer">
        <input
          type="number"
          placeholder="请输入手机号码"
          v-model="phoneNumber"
        />
        <div>
          <span @click="onGetYanzhengma">{{ msg }}</span>
        </div>
      </div>
      <div class="yanzhengma">
        <input type="number" placeholder="请输入验证码" v-model="yanzhengma" />
      </div>
      <div class="btnZhuce" @click="lijizhuce">立即注册</div>
    </div>

    <div class="container" v-if="isWangjimima">
      <img src="../src/assets/home/logo.png" alt="" class="logo" />
      <div class="phone infoContainer">
        <input
          type="number"
          placeholder="请输入手机号码"
          v-model="phoneNumber"
        />
        <div>
          <span @click="onGetXiugaimimaYanzhengma">{{ msg }}</span>
        </div>
      </div>
      <div class="yanzhengma">
        <input type="number" placeholder="请输入验证码" v-model="yanzhengma" />
      </div>

      <div class="xinmima">
        <input type="number" placeholder="请输入新密码" v-model="newPassword" />
      </div>

      <div class="btnZhuce" @click="xiugaimima">修改密码</div>
    </div>
    <!-- <Logo v-show="!$store.state.global.isTrans" class="logo1"/>
    <Logo v-show="$store.state.global.isTrans" class="logo2"/> -->
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import Logo from "../src/components/Logo.vue";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      isLoadingShow: true,
      isJti: false,
      username: "",
      password: "",
      iconUrl: "",
      isRemeber: false,
      isZhucezhanghao: false,
      phoneNumber: "",
      msg: "获取验证码",
      yanzhengma: "",
      isWangjimima: false,
      newPassword: "",
    };
  },
  components: { Logo },
  methods: {
    xiugaimima() {},
    wangjimima() {
      this.isWangjimima = true;
      this.msg = "获取验证码";
      this.phoneNumber = "";
      this.yanzhengma = "";
      this.newPassword = "";
    },
    isPoneAvailable(str) {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    onGetYanzhengma() {
      //判断是否是手机号码
      // if(!this.isPoneAvailable(this.phoneNumber)){
      //     this.$dialog.alert({
      //         message:'请输入正确的手机号码',
      //     })
      //     return
      // }
      if (this.msg === "获取验证码") {
        if (this.$store.state.global.isLoadingShow) {
          return;
        }
        this.$store.state.global.isLoadingShow = true;

        this.msg = "60";
        let timer = setInterval(() => {
          if (!this.isZhucezhanghao) {
            clearInterval(timer);
            return;
          }
          if (this.msg == "0") {
            clearInterval(timer);
            this.msg = "获取验证码";
            return;
          }
          this.msg = (parseInt(this.msg) - 1).toString();
        }, 1000);

        this.$axios({
          url: this.$store.state.global.url + "/v5/no/token/sendCheckCode",
          method: "post",
          data: {
            phone: this.phoneNumber,
          },
          headers: {
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            this.$store.state.global.isLoadingShow = false;
          },
          (error) => {
            this.$store.state.global.isLoadingShow = false;
            this.$dialog.alert({
              message: "验证码获取失败，请稍后重试！",
            });
          }
        );
      }
    },
    onGetXiugaimimaYanzhengma() {
      //判断是否是手机号码
      // if(!this.isPoneAvailable(this.phoneNumber)){
      //     this.$dialog.alert({
      //         message:'请输入正确的手机号码',
      //     })
      //     return
      // }
      if (this.msg === "获取验证码") {
        if (this.$store.state.global.isLoadingShow) {
          return;
        }
        this.$store.state.global.isLoadingShow = true;

        this.msg = "60";
        let timer = setInterval(() => {
          if (!this.isWangjimima) {
            clearInterval(timer);
            return;
          }
          if (this.msg == "0") {
            clearInterval(timer);
            this.msg = "获取验证码";
            return;
          }
          this.msg = (parseInt(this.msg) - 1).toString();
        }, 1000);

        this.$axios({
          url: this.$store.state.global.url + "/no/sendRegisterCode",
          method: "post",
          data: {
            phone: this.phoneNumber,
          },
          headers: {
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            this.$store.state.global.isLoadingShow = false;
          },
          (error) => {
            this.$store.state.global.isLoadingShow = false;
            this.$dialog.alert({
              message: "验证码获取失败，请稍后重试！",
            });
          }
        );
      }
    },
    xiugaimima() {
      //判断是否是手机号码
      // if(!this.isPoneAvailable(this.phoneNumber)){
      //     this.$dialog.alert({
      //         message:'请输入正确的手机号码',
      //     })
      //     return
      // }
      if (this.yanzhengma === "") {
        this.$dialog.alert({
          message: "请输入验证码",
        });
        return;
      }
      if (this.newPassword === "") {
        this.$dialog.alert({
          message: "请输入新密码",
        });
        return;
      }
      this.$store.state.global.isLoadingShow = true;
      this.$axios({
        url:
          this.$store.state.global.url + "/front/no/wuser/updatePwdByPhoneCode",
        method: "post",
        data: {
          phone: this.phoneNumber,
          code: this.yanzhengma,
          loginPwd: this.newPassword,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }).then(
        (response) => {
          this.$store.state.global.isLoadingShow = false;
          if (!response.data.success) {
            this.$dialog.alert({
              message: response.data.message,
            });
          } else {
            this.$dialog
              .alert({
                message: "密码修改成功！",
              })
              .then(() => {
                this.isWangjimima = false;
              });
          }
        },
        (error) => {
          this.$store.state.global.isLoadingShow = false;
          this.$dialog.alert({
            message: "修改密码失败，请稍后重试！",
          });
        }
      );
    },
    lijizhuce() {
      //判断是否是手机号码
      // if(!this.isPoneAvailable(this.phoneNumber)){
      //     this.$dialog.alert({
      //         message:'请输入正确的手机号码',
      //     })
      //     return
      // }
      if (this.yanzhengma === "") {
        this.$dialog.alert({
          message: "请输入验证码",
        });
        return;
      }
      this.$store.state.global.isLoadingShow = true;
      this.$axios({
        url: this.$store.state.global.url + "/v5/no/token/regPhoneCode",
        method: "post",
        data: {
          phone: this.phoneNumber,
          code: this.yanzhengma,
          length: 6,
          ueId: this.$route.query.ueId,
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          dsName: "",
        },
      }).then(
        (response) => {
          this.$store.state.global.isLoadingShow = false;
          if (!response.data.success) {
            this.$dialog.alert({
              message: response.data.message,
            });
          } else {
            this.$dialog
              .alert({
                message: response.data.data,
              })
              .then(() => {
                this.isZhucezhanghao = false;
              });
          }
        },
        (error) => {
          this.$store.state.global.isLoadingShow = false;
          this.$dialog.alert({
            message: "验证码验证失败，请稍后重试！",
          });
        }
      );
    },
    zhucezhanghao() {
      this.isZhucezhanghao = true;
      this.msg = "获取验证码";
      this.phoneNumber = "";
      this.yanzhengma = "";
      this.newPassword = "";
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    onGetUrl(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null) context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined"
        ? ""
        : context;
    },
    onGetToken() {
      return new Promise((resolve, reject) => {
        this.$axios({
          url:
            this.$store.state.global.url +
            "/v5/token/jti/front?jti=" +
            this.$store.state.global.jti,
          method: "get",
          headers: {
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            resolve(response.data);
          },
          (error) => {
            this.$dialog
              .alert({
                message: "token获取失败，请联系管理员",
              })
              .then(() => {
                reject(error);
              });
          }
        );
      });
    },
    onGetGlobalId() {
      return new Promise((resolve, reject) => {
        this.$axios({
          url:
            this.$store.state.global.url +
            this.$store.state.global.globalIdUrl +
            "t=" +
            new Date().getTime(),
          method: "get",
          headers: {
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            resolve(response.data);
          },
          (error) => {
            this.$dialog
              .alert({
                message: "id获取失败，请联系管理员",
              })
              .then(() => {
                reject(error);
              });
          }
        );
      });
    },
    //判断是否填过个人信息
    onGetInfo() {
      return new Promise((resolve, reject) => {
        this.$axios({
          url: this.$store.state.global.url + "/v5/yc-user-info/get",
          method: "get",
          headers: {
            Authorization: "Bearer " + this.$store.state.global.token,
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            resolve(response.data);
          },
          (error) => {
            this.$dialog
              .alert({
                message: "个人信息获取失败，请联系管理员",
              })
              .then(() => {
                reject(error);
              });
          }
        );
      });
    },
    //判断是否是第一次
    onCheckFirst() {
      return new Promise((resolve, reject) => {
        this.$axios({
          url:
            this.$store.state.global.url +
            "/visualplatpad/detector-report/countByUflyId",
          method: "get",
          headers: {
            Authorization: "Bearer " + this.$store.state.global.token,
            serverFlag: "",
            dsName: "",
          },
        }).then(
          (response) => {
            resolve(response.data);
          },
          (error) => {
            this.$dialog
              .alert({
                message: "判断是否是第一次评估失败，请联系管理员",
              })
              .then(() => {
                reject(error);
              });
          }
        );
      });
    },
    async onLogin() {
      this.$store.state.global.isLoadingShow = false;
      this.$store.state.global.isLoadingShow = true;
      if (this.$route.query.jti) {
        this.$store.state.global.jti = this.$route.query.jti;
        localStorage.setItem("jti", this.$store.state.global.jti);
      } else {
        this.$store.state.global.jti = localStorage.getItem("jti");
      }
      let result = await this.onGetToken();

      //判断jti有没有过期
      if (result.data.expiration < new Date().getTime()) {
        //令牌过期
        this.$dialog
          .alert({
            message: "令牌已过期，请重新登录",
          })
          .then(() => {
            //返回冯超或者关闭页面
            wx.miniProgram.navigateBack({ delta: 1 });
          });
        return;
      }
      console.log(result);
      this.$store.state.global.token = result.data.value;
      if (result.data.additionalInformation.phone != "") {
        this.$store.state.global.phone =
          result.data.additionalInformation.phone;
        this.$store.state.global.umemo =
          result.data.additionalInformation.umemo;
        this.$store.state.global.realName =
          result.data.additionalInformation.realName;
      }
      result = await this.onGetGlobalId();
      this.$store.state.global.globalId = result.data;
      this.$store.state.global.isLoadingShow = false;
      result = await this.onGetInfo();
      this.$store.state.global.userAge = result.data.userAge;
      if (result.data.onEye) {
        this.$store.state.global.personalInformationBol = true;
        this.$store.state.global.onEye = result.data.onEye;
      } else {
        this.$store.state.global.personalInformationBol = false;
      }
      result = await this.onCheckFirst();
      if (result.data > 0) {
        this.$store.state.global.isFirst = false;
      } else {
        this.$store.state.global.isFirst = true;
        this.$store.state.commonDescription.title[1] =
          "第1节  截止频率能力测试";
        this.$store.state.commonDescription.title[3] =
          "第2节  纹理感知能力测试";
        this.$store.state.commonDescription.title[4] =
          "第3节  纹理运动辨别能力测试";
      }
    },
    onRemeber() {
      if (this.isRemeber) {
        this.iconUrl = require("../src/assets/home/checkIcon_select.png");
      } else {
        this.iconUrl = require("../src/assets/home/checkIcon_selected.png");
      }
      this.isRemeber = !this.isRemeber;
    },
    async denglu() {
      if (this.username == "" || this.password == "") {
        this.$dialog.alert({
          message: "请填写正确的账号或者密码",
        });
        return;
      }
      this.$store.state.global.isLoadingShow = true;
      await new Promise((resolve, reject) => {
        this.$axios({
          url:
            this.$store.state.global.url +
            "/v5/oauth/token?username=" +
            this.username +
            "&password=" +
            this.password +
            "&grant_type=password&type=front-ai",
          method: "post",
          headers: {
            Authorization: "Basic S2ZfQWRtaW46YWRtaW4yNDY=",
            "Content-Type": "application/x-www-form-urlencoded",
            dsName: "",
          },
        }).then(
          (response) => {
            if (response.data.success) {
              if (this.isRemeber) {
                localStorage.setItem("username", this.username);
                localStorage.setItem("password", this.password);
              }

              this.$store.state.global.jti = response.data.data.jti;
              localStorage.setItem("jti", this.$store.state.global.jti);
              this.onLogin();
              this.isJti = true;
            } else {
              this.$dialog.alert({
                message: response.data.message,
              });
            }
          },
          (error) => {
            this.$dialog
              .alert({
                message: "账号密码登录失败",
              })
              .then(() => {
                reject(error);
              });
          }
        );
      });
      this.$store.state.global.isLoadingShow = false;
    },
  },
  async mounted() {
    if (this.$route.query.jti) {
      this.isJti = true;
      await this.onLogin();
    } else {
      if (this.$store.state.global.jti) {
        this.isJti = true;
        await this.onLogin();
      } else {
        this.isJti = false;
        //判断有没有记住密码
        if (
          localStorage.getItem("username") &&
          localStorage.getItem("password")
        ) {
          this.username = localStorage.getItem("username");
          this.password = localStorage.getItem("password");
          this.iconUrl = require("../src/assets/home/checkIcon_selected.png");
          this.isRemeber = true;
        } else {
          this.username = "";
          this.password = "";
          this.iconUrl = require("../src/assets/home/checkIcon_select.png");
          this.isRemeber = false;
        }
      }
    }
  },
};
</script>

<style scoped>
.container {
  background: white;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
}
#loginContainer {
  width: 80vw;
  margin-left: 10vw;
  margin-top: 30vw;
}
#loginContainer img {
  width: 5vw;
  height: 5vw;
}
#loginContainer input {
  border: none;
  width: 60vw;
  height: 10vw;
  font-size: 4vw;
  padding-left: 10vw;
}
.inputContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgb(165, 165, 165);
  margin-top: 5vw;
}
.btnNext {
  background: rgb(192, 204, 224);
  color: rgb(79, 79, 79);
  width: 80vw;
  border-radius: 5vw;
  height: 10vw;
  text-align: center;
  line-height: 10vw;
  font-size: 4vw;
  margin-top: 15vw;
}
.btnWangjimima {
  background: rgb(100, 191, 228);
  color: rgb(255, 255, 255);
  width: 80vw;
  border-radius: 5vw;
  height: 10vw;
  text-align: center;
  line-height: 10vw;
  font-size: 4vw;
  margin-top: 2vw;
}
.mimaxiangguanContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5vw;
}
.jizhumima {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo {
  margin-top: 20vw;
  margin-left: 25vw;
  width: 50vw;
}
#loadingContainer {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.logo2 {
  position: absolute;
  top: 92%;
}

.infoContainer div {
  position: absolute;
  right: 20%;
  top: 50%;
  transform: translate(0%, -50%);
}
.infoContainer span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 3vw;
  white-space: nowrap;
}

.phone {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
}

.yanzhengma {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, 0%);
}

.xinmima {
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translate(-50%, 0%);
}

input {
  border: none;
  border-bottom: 1px solid rgb(165, 165, 165);
  width: 70vw;
  height: 10vw;
  font-size: 4vw;
  padding-left: 10vw;
}

.btnZhuce {
  background: rgb(192, 204, 224);
  color: rgb(79, 79, 79);
  width: 80vw;
  border-radius: 5vw;
  height: 10vw;
  text-align: center;
  line-height: 10vw;
  font-size: 4vw;
  position: absolute;
  left: 50%;
  top: 80%;
  transform: translate(-50%, 0%);
}
</style>
